export default __webpack_public_path__ + "img/icNqhmxr.71c679d1.svg";